import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Layout from "./components/Layout";
import AppRoutes from "./routes";
import { Toaster } from "sonner";

function App() {
  return (
    <Router>
      <Layout>
        <AppRoutes />
        <Toaster richColors position="top-right" closeButton />
      </Layout>
    </Router>
  );
}

export default App;
